module.exports = __webpack_public_path__ + "img/bin.6dc0040c.svg";